export default "__VITE_ASSET__BDhzzJ9e__"